// frontend/src/components/roleplay/RoleplayPrintDocument.js
//
// Hidden document rendered alongside the roleplay UI so the topbar's
// print button can produce a PDF (via window.print()) containing the
// situation, gold version script, and debrief — regardless of which
// tab is currently open in the side panel.

import PropTypes from 'prop-types';
import RoleplayDebriefView from './RoleplayDebriefView';

const SITUATION_FIELDS = [
  { label: 'Counterpart',        getValue: cs => cs?.characterBrief?.inSum?.content },
  { label: 'Real Issue',  getValue: cs => cs?.realIssue?.summary?.content },
  { label: 'Data & Reasoning',   getValue: cs => cs?.realIssue?.dataAndReasoning?.content },
  { label: 'Stakes — Downsides', getValue: cs => cs?.characterStakes?.downSides?.inSum?.content },
  { label: 'Stakes — Upsides',   getValue: cs => cs?.characterStakes?.upSides?.inSum?.content },
  { label: 'Desired Outcome',    getValue: cs => cs?.desiredOutcome?.content },
  { label: 'Challenge',          getValue: cs => cs?.challenge?.content },
];

const RoleplayPrintDocument = ({ conversationTitle, caseStudy, exchanges = [], characterName, debriefReport, debriefNotReadyMessage }) => (
  <div className="rp-print-root">
    <h1 className="rp-print-doc-title">{conversationTitle || 'Roleplay Session'}</h1>

    <section className="rp-print-section">
      <h2 className="rp-print-section-title">Situation</h2>
      {caseStudy ? (
        <div className="rp-script-list">
          {SITUATION_FIELDS.map(({ label, getValue }) => {
            const value = getValue(caseStudy);
            if (!value) return null;
            return (
              <div key={label} className="rp-impl-cs-section">
                <div className="rp-impl-cs-label">{label}</div>
                <div className="rp-impl-cs-value">{value}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="rp-script-empty">Situation not available.</p>
      )}
    </section>

    <section className="rp-print-section rp-print-page-break">
      <h2 className="rp-print-section-title">Gold Version</h2>
      {exchanges.length === 0 ? (
        <p className="rp-script-empty">No exchanges captured.</p>
      ) : (
        <div className="rp-script-list">
          {exchanges.map((ex, i) => (
            <div key={i} className="rp-script-exchange">
              {ex.characterText && (
                <>
                  <div className="rp-script-speaker-label them">{characterName || 'them'}</div>
                  <p className="rp-script-text character">{ex.characterText}</p>
                </>
              )}
              {ex.clientText && (
                <>
                  <div className="rp-script-speaker-label you">You</div>
                  <p className="rp-script-text">{ex.clientText}</p>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </section>

    <section className="rp-print-section rp-print-page-break">
      <RoleplayDebriefView report={debriefReport} notReadyMessage={debriefNotReadyMessage} />
    </section>
  </div>
);

RoleplayPrintDocument.propTypes = {
  conversationTitle: PropTypes.string,
  caseStudy: PropTypes.object,
  exchanges: PropTypes.arrayOf(
    PropTypes.shape({
      clientText: PropTypes.string,
      characterText: PropTypes.string,
    })
  ),
  characterName: PropTypes.string,
  debriefReport: PropTypes.object,
  debriefNotReadyMessage: PropTypes.string,
};

export default RoleplayPrintDocument;
